export var SocialEnterpriseLimitation;
(function (SocialEnterpriseLimitation) {
    SocialEnterpriseLimitation[SocialEnterpriseLimitation["GUARANTEE"] = 0] = "GUARANTEE";
    SocialEnterpriseLimitation[SocialEnterpriseLimitation["SHARES"] = 1] = "SHARES";
})(SocialEnterpriseLimitation || (SocialEnterpriseLimitation = {}));
